/* Native responsive sources stay intact; warm only images near the viewport. */
(() => {
  const bound = new WeakSet();
  const selector = '.jg-series__photo, .jg-editorial__category-image, .product-card-wrapper .card__media img, .product__media img';
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.loading = 'eager';
      observer.unobserve(entry.target);
    }
  }, { rootMargin: '600px 0px' }) : null;
  function bind(root) {
    for (const img of root.querySelectorAll(selector)) {
      if (bound.has(img)) continue;
      bound.add(img);
      const card = img.closest('.product-card-wrapper');
      const secondary = card?.querySelector('.card__media .media > img + img');
      if (img === secondary) {
        const ready = () => { if (img.naturalWidth > 0) card.dataset.jgSecondaryReady = 'true'; };
        img.addEventListener('load', ready, { once: true });
        if (img.complete) ready();
      }
      if (observer) observer.observe(img);
      else img.loading = 'eager';
    }
  }
  const main = document.querySelector('#MainContent');
  if (!main) return;
  bind(main);
  new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length)) bind(main);
  }).observe(main, { childList: true, subtree: true });
})();
